var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00867 6.48657C1.04463 8.17265 1.06261 9.01564 1.68473 9.64016C2.30684 10.2646 3.17268 10.2864 4.90435 10.3299C5.97161 10.3567 7.02838 10.3567 8.09565 10.3299C9.82732 10.2864 10.6931 10.2646 11.3153 9.64016C11.9374 9.01564 11.9554 8.17265 11.9913 6.48657C12.0029 5.94444 12.0029 5.40555 11.9913 4.86342C11.9554 3.17737 11.9374 2.33435 11.3153 1.70986C10.6931 1.08538 9.82732 1.06362 8.09565 1.02011C7.02838 0.993296 5.97161 0.993296 4.90435 1.02011C3.17268 1.06361 2.30684 1.08537 1.68472 1.70986C1.0626 2.33434 1.04463 3.17737 1.00867 4.86342C0.997107 5.40555 0.997113 5.94444 1.00867 6.48657Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.375L4.80216 4.52933C6.20387 5.32355 6.79611 5.32355 8.19784 4.52933L12 2.375",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.596d643d23cf016e5b174bb1383b2c6e.svg";
export { ForwardRef as ReactComponent };